import { RouterModule } from '@angular/router';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { LetModule, PushModule } from '@ngrx/component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TippyModule } from '@ngneat/helipopper';

// Internal imports
import { facades } from './state/facades';
import { containerComponents } from './containers';
import {
  AccountSignatureComponent,
  ChipComponent,
  components,
  HorizontalNavigationComponent,
  NgbTimePickerComponent,
  SearchableSelectComponent,
  SearchableSelectFormControlComponent,
  UnsavedChangesComponent,
  SectionTitleComponent,
  TimeComponent,
  AttachmentsUploadComponent,
  MultiselectComponent,
} from './components';
import { SvgIconsModule } from './svg-icons/svg-icons.module';
import { pipes } from './pipes';
import {
  BaseUrlInterceptor,
  ClientHttpInterceptor,
  ErrorHttpInterceptor,
  LoaderHttpInterceptor,
} from './http-interceptors';
import { directives } from './directives';
import { services } from './services';
import { FileUploadButtonComponent } from './components/file-upload';
import { MaterialModule } from './material';
import { GridModule } from '@grid/grid.module';

const exportedComponents = [
  FileUploadButtonComponent,
  AccountSignatureComponent,
  ChipComponent,
  HorizontalNavigationComponent,
  NgbTimePickerComponent,
  SearchableSelectComponent,
  SearchableSelectFormControlComponent,
  UnsavedChangesComponent,
  SectionTitleComponent,
  TimeComponent,
  AttachmentsUploadComponent,
  MultiselectComponent,
];
const exportedModules = [
  FormsModule,
  ReactiveFormsModule,
  MaterialModule,
  SvgIconsModule,
  PortalModule,
  ClipboardModule,
  LetModule,
  PushModule,
  ScrollingModule,
  InfiniteScrollModule,
  NgxMatSelectSearchModule,
  TippyModule,
];

@NgModule({
  declarations: [components, containerComponents, pipes, directives],
  exports: [GridModule, exportedComponents, exportedModules, pipes, directives],
  imports: [
    CommonModule,
    RouterModule,
    ClipboardModule,
    exportedModules,
    GridModule,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        facades,
        services,
        pipes,
        DatePipe,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ClientHttpInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: BaseUrlInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ErrorHttpInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LoaderHttpInterceptor,
          multi: true,
        },
      ],
    };
  }
}
